import api from "../api";
import config from "../config";

export async function loadServices() {
  try {
    const res = await api.get("getProductList");

    const products = Array.isArray(res.data?.data) ? res.data.data : [];

    return products.map((item, index) => {
      // Convert comma-separated images into an array
      const images = item.images
        ? item.images
            .split(",")
            .map((img) => img.trim())
            .filter(Boolean)
            .map((img) => `${config.baseUrl}${img}`)
        : [];

      // Add main image as first image if it exists
      const mainImage = item.image
        ? `${config.baseUrl}${item.image}`
        : "https://via.placeholder.com/300";

      return {
        id: Number(item.id) || Number(index + 1),

        title: item.title || "",
        subtitle: item.subtitle || "",
        category: item.category || "",

        price: Number(item.price) || 0,
        oldPrice: Number(item.oldPrice) || 0,

        discount: item.discount ? `${item.discount}% off` : "",

        weight: item.weight || "",

        // Main product image
        image: mainImage,

        // Multiple product images
        images: images.length > 0 ? images : [mainImage],

        rating: Number(item.rating) || 0,
        reviews: Number(item.reviews) || 0,

        tag: item.tag || "",
        description: item.description || "",
      };
    });
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
}
